module.exports = __webpack_public_path__ + "static/media/result_nare_cup2023-1.18aa2bb1.jpg";